import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'

import { authReducer } from './auth/reducer'
import {
  desktopReducer,
  orcReducer,
  quizReducer,
  requestReducer,
  tokenReducer,
  formReducer,
} from './reducers'

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    auth: authReducer,
    desktop: desktopReducer,
    ocr: orcReducer,
    quiz: quizReducer,
    request: requestReducer,
    token: tokenReducer,
    form: formReducer,
  })
